import { PencilIcon, ZapIcon, ListOrderedIcon, GlobeIcon, GiftIcon, SmartphoneIcon, LockIcon } from 'lucide-react';

export const systemFeatures = [
  { icon: PencilIcon, label: 'Fichas listas para imprimir' },
  { icon: ZapIcon, label: 'Clases estructuradas para consultar' },
  { icon: ListOrderedIcon, label: 'Orden progresivo por tomo' },
  { icon: GlobeIcon, label: 'Contenido para todo el mundo hispanohablante' },
  { icon: GiftIcon, label: '6 Bonos exclusivos incluidos' },
  { icon: SmartphoneIcon, label: '100% descargable en PDF' },
  { icon: LockIcon, label: 'Acceso de por vida' }
];
